import React from "react";
import BookingProducts from "../../BookingProducts/BookingProducts";
import BookingFlowTotal from "../BookingFlowTotal";

export default class BookingAddOnsTab extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="AddOns" style={{margin: '0 15px'}}>
        <BookingProducts
          totalComponent={<div className="BookingTotal"><BookingFlowTotal {...this.props} /></div>}
          continueButton={<button type="button" className="btn btn-block btn-primary" onClick={() => this.props.onChangeStep('total')}>{I18n.t('continue_to_book')}</button>}
          cart={this.props.add_ons}
          {...this.props}
        />
      </div>
    );
  }

};
